import VehicleInfoGroupTree from './vehicle-info-group-tree.vue'
export default VehicleInfoGroupTree
